import React from 'react';
import SuggestionBlogCard from './SuggestionBlogCard/SuggestionBlogCard';
import * as classes from './blogpostSuggestionFooter.module.css';

export default function BlogpostSuggestionFooter({ suggestionBlogs, blogId }) {
  let blogs = [];
  suggestionBlogs.forEach((blog) => {
    if (blog.id !== blogId) blogs.push(blog);
  });

  blogs = blogs.slice(0, 4);
  if (!blogs.length) {
    return <></>;
  }
  return (
    <>
      <h1 className={classes.suggested_posts}>More for you to read</h1>
      <div className={classes.container}>
        <div className={classes.flex_container}>
          {blogs.map((blog) => (
            <SuggestionBlogCard blog={blog} key={blog.id} />
          ))}
        </div>
      </div>
    </>
  );
}
